module.exports = __webpack_public_path__ + "media/img/logo-livetrend-5c613380b276a72816e756e481b5c6b4.svg";